import React from 'react';
import ModuleOverview from './ModuleOverview';
const Overview = ({ pll, formData, attributes, showModules = false, showInformations = false }) => {
    let modulesNode = "";
    if (formData.modules.length > 0) {
        modulesNode = formData.modules.map((id) => {
            if (formData.modulesRaw.modules.hasOwnProperty(id)) {
                let module = formData.modulesRaw.modules[id];
                return React.createElement(ModuleOverview, { title: module.formationInformations + (module.formationInformations != "" ? ": " : "") + module.formationName, element: module, attributes: attributes });
            }
        });
    }
    return (React.createElement("section", { className: "section-wrapper overview" },
        React.createElement("h2", null, pll("Récapitulatif")),
        !showModules ? "" : React.createElement("div", { className: "modules" }, modulesNode),
        !showInformations ? "" : React.createElement("div", { className: "informations" },
            React.createElement("div", { className: "service" },
                React.createElement("h3", null, pll("Coordonnées du service")),
                React.createElement("ul", null,
                    React.createElement("li", null, formData.service_email),
                    React.createElement("li", null, formData.service_name),
                    React.createElement("li", null, formData.service_address),
                    React.createElement("li", null,
                        formData.service_zip_code,
                        ",",
                        formData.service_city),
                    React.createElement("li", null, formData.service_phone),
                    React.createElement("li", null, formData.service_type))),
            React.createElement("div", { className: "person" },
                React.createElement("h3", null, pll("Informations personnelles")),
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement("strong", null,
                            formData.person_first_name,
                            " ",
                            formData.person_last_name)),
                    React.createElement("li", null, formData.person_date),
                    React.createElement("li", null, formData.person_function),
                    React.createElement("li", null, formData.person_email),
                    React.createElement("li", null, formData.person_mobile))))));
};
export default Overview;
